import { Route, Routes } from "react-router-dom";
import "./App.css";
import ProtectedRoute from "./components/protectedRoute/protectedRoute";
import ComingSoon from "./pages/comingSoon/comingSoon";
import PageNotFound from "./pages/pageNotFound/pageNotFound";
import Tables from "./pages/tables/tables";
import AllStudents from "./pages/learners/allStudents/allStudents";
import SignIn from "./pages/signIn/signIn";

const protectedRoutes = [
  { path: "/", element: <ComingSoon title="Dashboard Page" /> },
  { path: "/dashboard", element: <ComingSoon title="Dashboard Page" /> },
  { path: "/learners/all-learners/*", element: <AllStudents /> },
  { path: "/enrollments", element: <ComingSoon title="Enrollments Page" /> },
  { path: "/certifications", element: <ComingSoon title="Certifications Page" /> },
  { path: "/integrations", element: <ComingSoon title="Integrations Page" /> },
  { path: "/reports", element: <ComingSoon title="Reports Page" /> },
  { path: "/communication", element: <ComingSoon title="Communication Page" /> },
  { path: "/users-roles", element: <ComingSoon title="Users & Roles Page" /> },
  { path: "/settings", element: <ComingSoon title="Settings Page" /> },
];

const App = () => {
  return (
    <div className="wrapper" id="toogleWrapper">
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        {protectedRoutes.map(({ path, element }, i) => {
          return <Route key={i} path={path} element={<ProtectedRoute>{element}</ProtectedRoute>} />;
        })}

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
};

export default App;
